// userSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../services/AxiosInstance";

// Create an async thunk to fetch user data
export const fetchvendorData = createAsyncThunk(
  "user/fetchvendorData",
  async () => {
    try {
      const response = await axiosInstance.get("admin/get/all/vendors");
      return response.data.data;
    } catch (error) {
      throw error;
    }
  }
);

const vendorSlice = createSlice({
  name: "vendor",
  initialState: {
    data: [],
    userCount: 0,
    loading: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchvendorData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchvendorData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.vendorCount = action.payload.length;
      })
      .addCase(fetchvendorData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default vendorSlice.reducer;
